let page_schema = {
    "tiers": [
      {
        "name": "Sample Type",
        "type": "checkbox",
        "id": "sample-types",
        "class_name": "tags",
        "child_name": "sample-type",
        "options": [
          {
            "name": "Agarose Gel",
            "id": "agarose-gel"
          },
          {
            "name": "All-Purpose Extraction",
            "id": "all-purpose-extraction"
          },
          {
            "name": "Bacteria",
            "id": "bacteria"
          },
          {
            "name": "Biological Fluids (CSF, Amniotic Fluid, Serum, Plasma, etc. )",
            "id": "biological-fluids-csf-amniotic-fluid-serum-plasma-etc"
          },
          {
            "name": "Blood",
            "id": "blood"
          },
          {
            "name": "Cells",
            "id": "cells"
          },
          {
            "name": "Crude Extracts & Purified DNA or RNA",
            "id": "crude-extracts-and-purified-dna-or-rna"
          },
          {
            "name": "Feces",
            "id": "feces"
          },
          {
            "name": "FFPE Tissue",
            "id": "ffpe"
          },
          {
            "name": "Insect",
            "id": "insect"
          },
          {
            "name": "Microbial Cultures",
            "id": "microbial-cultures"
          },
          {
            "name": "Plant/Seed",
            "id": "plant-seed"
          },
          {
            "name": "Reaction Products and Aqueous Phase",
            "id": "reaction-products-and-aqueous-phase"
          },
          {
            "name": "Slide",
            "id": "slide"
          },
          {
            "name": "Soil & Water",
            "id": "soil-and-water"
          },
          {
            "name": "Storage Papers, Hair, Feather, Nails",
            "id": "storage-papers-hair-feather-nails"
          },
          {
            "name": "Swabs & Saliva",
            "id": "swabs-and-saliva"
          },
          {
            "name": "Tissue",
            "id": "tissue"
          },
          {
            "name": "Urine",
            "id": "urine"
          },
          {
            "name": "Virus",
            "id": "virus"
          },
          {
            "name": "Yeast/Fungi",
            "id": "yeast-fungi"
          }
        ]
      },
      {
        "name": "Features",
        "type": "checkbox",
        "id": "features",
        "class_name": "tags",
        "child_name": "feature",
        "options": [
          {
            "name": "CE-IVD",
            "id": "ce-ivd"
          },
          {
            "name": "Cell-Free DNA",
            "id": "cell-free-dna"
          },
          {
            "name": "Certified Low Bioburden",
            "id": "certified-low-bioburden"
          },
          {
            "name": "High Sample Input",
            "id": "high-sample-input"
          },
          {
            "name": "High-Throughput",
            "id": "high-throughput"
          },
          {
            "name": "HMW DNA",
            "id": "hmw-dna"
          },
          {
            "name": "Host DNA Depletion",
            "id": "host-dna-depletion"
          },
          {
            "name": "Low Sample Input",
            "id": "low-sample-input"
          },
          {
            "name": "Microbiome/ Metagenome Analysis",
            "id": "microbiome-metagenome-analysis"
          },
          {
            "name": "Nucleosomal DNA Isolation",
            "id": "nucleosomal-dna-isolation"
          },
          {
            "name": "Physical Lysis",
            "id": "physical-lysis"
          },
          {
            "name": "Plasmid Purification",
            "id": "plasmid-purification"
          },
          {
            "name": "Proteinase K Included",
            "id": "proteinase-k-included"
          },
          {
            "name": "Total Nucleic Acid (DNA/RNA) Purification",
            "id": "total-nucleic-acid-dna-rna-purification"
          }
        ]
      },
      {
        "name": "Formats",
        "type": "checkbox",
        "id": "formats",
        "class_name": "tags",
        "child_name": "format",
        "options": [
          {
            "name": "Spin Columns",
            "id": "spin-columns"
          },
          {
            "name": "96-Well Plate",
            "id": "96-well-plate"
          },
          {
            "name": "Magnetic Beads (Automatable)",
            "id": "magnetic-beads-automatable"
          }
        ]
      },
      {
        "name": "d-none",
        "type": "checkbox",
        "id": "d-none",
        "class_name": "tags",
        "child_name": "d-none",
        "options": [
          {
            "name": "Automated & High-Throughput",
            "id": "automated-high-throughput",
          }
        ]
      }
    ],
    "filters": [],
    "products": {
      "Quick-DNA Miniprep Plus Kit": {
        "title": "<i>Quick</i>-DNA Miniprep Plus Kit",
        "catalogNumbers": "D4068, D4068T, D4069",
        "description": "Recover high yields of total DNA in just 35 µl from cells, tissues, and any biological fluid in only 20 minutes.",
        "handle": "/products/quick-dna-miniprep-plus-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4068.jpg",
        "generalIndex": "2",
        "id": "quick-dna-miniprep-plus-kit",
        "tags": [
          "all-purpose-extraction",
          "blood",
          "cells",
          "tissue",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "virus",
          "storage-papers-hair-feather-nails",
          "proteinase-k-included",
          "hmw-dna",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA Microprep Plus Kit": {
        "title": "<i>Quick</i>-DNA Microprep Plus Kit",
        "catalogNumbers": "D4074",
        "description": "Recover high yields of total DNA in just 10 µl from cells, tissues, and any biological fluid in only 20 minutes.",
        "handle": "/products/quick-dna-microprep-plus-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4074.jpg",
        "generalIndex": "1",
        "id": "quick-dna-microprep-plus-kit",
        "tags": [
          "all-purpose-extraction",
          "blood",
          "cells",
          "tissue",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "virus",
          "storage-papers-hair-feather-nails",
          "low-sample-input",
          "proteinase-k-included",
          "hmw-dna",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA Midiprep Plus Kit": {
        "title": "<i>Quick</i>-DNA Midiprep Plus Kit",
        "catalogNumbers": "D4075",
        "description": "Isolate ultra-pure total DNA from high inputs of cells, tissues, and any biological fluid using a fast spin-column protocol.",
        "handle": "/products/quick-dna-midiprep-plus-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4075.jpg",
        "generalIndex": "3",
        "id": "quick-dna-midiprep-plus-kit",
        "tags": [
          "all-purpose-extraction",
          "blood",
          "cells",
          "tissue",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "virus",
          "storage-papers-hair-feather-nails",
          "high-sample-input",
          "proteinase-k-included",
          "hmw-dna",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA Magbead Plus Kit": {
        "title": "<i>Quick</i>-DNA Magbead Plus Kit",
        "catalogNumbers": "D4081, D4082",
        "description": "Automatable purification of high-quality total DNA from cells, tissues, and any biological fluid.",
        "handle": "/products/quick-dna-magbead-plus-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4081.jpg",
        "generalIndex": "5",
        "id": "quick-dna-magbead-plus-kit",
        "tags": [
          "all-purpose-extraction",
          "blood",
          "cells",
          "tissue",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "virus",
          "storage-papers-hair-feather-nails",
          "high-throughput",
          "automated-high-throughput",
          "automated-high-throughput",
          "proteinase-k-included",
          "hmw-dna",
          "magnetic-beads-automatable"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 1
          // }
        ]
      },
      "Quick-DNA 96 Plus Kit": {
        "title": "<i>Quick</i>-DNA 96 Plus Kit",
        "catalogNumbers": "D4070, D4071",
        "description": "High-throughput purification of high-quality total DNA from cells, tissues, and any biological fluid.",
        "handle": "/products/quick-dna-96-plus-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4071.jpg",
        "generalIndex": "4",
        "id": "quick-dna-96-plus-kit",
        "tags": [
          "all-purpose-extraction",
          "blood",
          "cells",
          "tissue",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "virus",
          "storage-papers-hair-feather-nails",
          "high-throughput",
          "automated-high-throughput",
          "proteinase-k-included",
          "hmw-dna",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 0
          // }
        ]
      },
      "ZymoPURE Plasmid Miniprep Kit": {
        "title": "ZymoPURE Plasmid Miniprep Kit",
        "catalogNumbers": "D4208T, D4209, D4210, D4211, D4212",
        "description": "Rapid spin-column purification of transfection-grade plasmid DNA from up to 5 ml of <i>E. coli</i> culture.",
        "handle": "/products/zymopure-ii-plasmid-miniprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4212.webp",
        "generalIndex": "6",
        "id": "zymopure-ii-plasmid-miniprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "plasmid-purification",
            "le-25-kb",
          "spin-columns"
        ],
        "filters": []
      },
      "ZymoPURE - Express Plasmid Midiprep Kit": {
        "title": "ZymoPURE - Express Plasmid Midiprep Kit",
        "catalogNumbers": "D4213",
        "description": "Purify transfection-grade plasmid DNA from 25 ml of <i>E. coli</i> culture without pelleting cells.",
        "handle": "/products/zymopure-express-plasmid-midiprep-kit",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4213_ZymoPURE---Express-Plasmid-Midiprep-Kit.jpg?v=1639434343&width=600",
        "generalIndex": "11",
        "id": "zymopure-express-plasmid-midiprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "plasmid-purification",
            "le-25-kb",
          "spin-columns"
        ],
        "filters": []
      },
      "ZymoPURE II Plasmid Midiprep Kit": {
        "title": "ZymoPURE II Plasmid Midiprep Kit",
        "catalogNumbers": "D4200, D4201",
        "description": "Purify up to 1.2 mg of endotoxin-free plasmid DNA in less than 18 minutes using a simple spin-column protocol.",
        "handle": "/products/zymopure-ii-plasmid-midiprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4200.webp",
        "generalIndex": "7",
        "id": "zymopure-ii-plasmid-midiprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "plasmid-purification",
            "le-25-kb",
          "spin-columns"
        ],
        "filters": []
      },
      "ZymoPURE II Plasmid Maxiprep Kit": {
        "title": "ZymoPURE II Plasmid Maxiprep Kit",
        "catalogNumbers": "D4202, D4203",
        "description": "Purify up to 3.0 mg of endotoxin-free plasmid DNA in less than 18 minutes using a simple spin-column protocol.",
        "handle": "/products/zymopure-ii-plasmid-maxiprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4202.webp",
        "generalIndex": "8",
        "id": "zymopure-ii-plasmid-maxiprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "plasmid-purification",
            "le-25-kb",
          "spin-columns"
        ],
        "filters": []
      },
      "ZymoPURE II Plasmid Gigaprep Kit": {
        "title": "ZymoPURE II Plasmid Gigaprep Kit",
        "catalogNumbers": "D4204",
        "description": "Rapidly purify up to 25 mg of endotoxin-free plasmid DNA using a simple spin-column protocol.",
        "handle": "/products/zymopure-ii-plasmid-gigaprep-kit",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4204_ZymoPURE-II-Plasmid-Gigaprep-Kit.jpg?v=1639429337&width=600",
        "generalIndex": "9",
        "id": "zymopure-ii-plasmid-gigaprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "plasmid-purification",
            "le-25-kb",
          "spin-columns"
        ],
        "filters": []
      },
      "ZymoPURE 96 Plasmid Miniprep Kit": {
        "title": "ZymoPURE 96 Plasmid Miniprep Kit",
        "catalogNumbers": "D4214, D4215, D4216",
        "description": "High-throughput purification of transfection-grade plasmid DNA from up to 5 ml of overnight <i>E. coli</i> culture using a vacuum or centrifuge.",
        "handle": "/products/zymopure-96",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/D4214_D4215_ZymoPURE96Kit.jpg?v=1688420296&width=600",
        "generalIndex": "10",
        "id": "zymopure-96",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "high-throughput",
          "automated-high-throughput",
            "le-25-kb",
          "plasmid-purification",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 15
          // }
        ]
      },
      "DNA Clean & Concentrator-5": {
        "title": "DNA Clean & Concentrator-5",
        "catalogNumbers": "D4003, D4003T, D4004, D4013, D4014",
        "description": "Purify up to 5 µg of highly concentrated ultra-pure DNA from PCR, enzymatic reactions, and other sources in 2 minutes.",
        "handle": "/products/dna-clean-concentrator-5",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4004.webp",
        "generalIndex": "12",
        "id": "dna-clean-concentrator-5",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "crude-extracts-and-purified-dna-or-rna",
          "spin-columns"
        ],
        "filters": []
      },
      "DNA Clean & Concentrator-25": {
        "title": "DNA Clean & Concentrator-25",
        "catalogNumbers": "D4005, D4006, D4033, D4034",
        "description": "Purify up to 25 µg of highly concentrated ultra-pure DNA from PCR, enzymatic reactions, and other sources in 2 minutes.",
        "handle": "/products/dna-clean-concentrator-25",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4005.webp",
        "generalIndex": "13",
        "id": "dna-clean-concentrator-25",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "crude-extracts-and-purified-dna-or-rna",
          "spin-columns"
        ],
        "filters": []
      },
      "DNA Clean & Concentrator-100": {
        "title": "DNA Clean & Concentrator-100",
        "catalogNumbers": "D4029, D4030",
        "description": "Quickly purify up to 100 µg of highly concentrated ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
        "handle": "/products/dna-clean-concentrator-100",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4029_DNA-Clean-and-Concentrator-100-Kit.jpg?v=1628532369&width=600",
        "generalIndex": "14",
        "id": "dna-clean-concentrator-100",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "crude-extracts-and-purified-dna-or-rna",
          "spin-columns"
        ],
        "filters": []
      },
      "DNA Clean & Concentrator-500": {
        "title": "DNA Clean & Concentrator-500",
        "catalogNumbers": "D4031, D4032",
        "description": "Quickly purify up to 500 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
        "handle": "/products/dna-clean-concentrator-500",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4031-DNA-Clean-_-Concentrator--500.jpg?v=1628532352&width=600",
        "generalIndex": "15",
        "id": "dna-clean-concentrator-500",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "crude-extracts-and-purified-dna-or-rna",
          "spin-columns"
        ],
        "filters": []
      },
      "DNA Clean & Concentrator Magbead Kit": {
        "title": "DNA Clean & Concentrator Magbead Kit",
        "catalogNumbers": "D4012",
        "description": "Automatable method for purifying up to 4 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
        "handle": "/products/dna-clean-concentrator-magbead-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4012.webp",
        "generalIndex": "18",
        "id": "dna-clean-concentrator-magbead-kit",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "crude-extracts-and-purified-dna-or-rna",
          "high-throughput",
          "automated-high-throughput",
          // "96-well-plate",
          "magnetic-beads-automatable"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 13
          // }
        ]
      },
      "Zymoclean Gel DNA Recovery Kit": {
        "title": "Zymoclean Gel DNA Recovery Kit",
        "catalogNumbers": "D4001, D4001T, D4002, D4007, D4008",
        "description": "Simple and quick isolation of highly concentrated ultra-pure DNA from TAE/TBE buffered agarose gels.",
        "handle": "/products/zymoclean-gel-dna-recovery-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4001.webp",
        "generalIndex": "19",
        "id": "zymoclean-gel-dna-recovery-kit",
        "tags": [
          "agarose-gel",
          "reaction-products-and-aqueous-phase",
          "spin-columns"
        ],
        "filters": []
      },
      "OneStep PCR Inhibitor Removal Kit": {
        "title": "<i>OneStep</i> PCR Inhibitor Removal Kit",
        "catalogNumbers": "D6031",
        "description": "Easily remove common PCR inhibitors from extracted DNA and RNA using a single step spin-column protocol.",
        "handle": "/products/onestep-pcr-inhibitor-removal-new-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6031.webp",
        "generalIndex": "21",
        "id": "onestep-pcr-inhibitor-removal-new-kit",
        "tags": [
          "crude-extracts-and-purified-dna-or-rna",
          "spin-columns"
        ],
        "filters": []
      },
      "OneStep-96 PCR Inhibitor Removal Kit": {
        "title": "<i>OneStep</i>-96 PCR Inhibitor Removal Kit",
        "catalogNumbers": "D6035",
        "description": "High-throughput removal of common PCR inhibitors from extracted DNA and RNA using a single step protocol.",
        "handle": "/products/onestep-pcr-inhibitor-removal-new-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6035.webp",
        "generalIndex": "22",
        "id": "onestep-pcr-inhibitor-removal-new-kit",
        "tags": [
          "crude-extracts-and-purified-dna-or-rna",
          "high-throughput",
          "automated-high-throughput",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 8
          // }
        ]
      },
      "Quick-DNA Fungal/Bacterial Microprep Kit": {
        "title": "<i>Quick</i>-DNA Fungal/Bacterial Microprep Kit",
        "catalogNumbers": "D6007",
        "description": "Simple and rapid isolation of ultra-pure DNA from up to 20 mg of tough-to-lyse fungi, Gram (+/-) bacteria, algae, and protozoa.",
        "handle": "/products/quick-dna-fungal-bacterial-microprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6007.jpg",
        "generalIndex": "27",
        "id": "quick-dna-fungal-bacterial-microprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "yeast-fungi",
          "low-sample-input",
          "physical-lysis",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA Fungal/Bacterial Miniprep Kit": {
        "title": "<i>Quick</i>-DNA Fungal/Bacterial Miniprep Kit",
        "catalogNumbers": "D6005",
        "description": "Simple and rapid isolation of ultra-pure DNA from up to 100 mg of tough-to-lyse fungi, Gram (+/-) bacteria, algae, and protozoa.",
        "handle": "/products/quick-dna-fungal-bacterial-miniprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6005.jpg",
        "generalIndex": "28",
        "id": "quick-dna-fungal-bacterial-miniprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "yeast-fungi",
          "physical-lysis",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA Fungal/Bacterial Midiprep Kit": {
        "title": "<i>Quick</i>-DNA Fungal/Bacterial Midiprep Kit",
        "catalogNumbers": "D6105",
        "description": "Simple and rapid isolation of ultra-pure DNA from up to 500 mg of tough-to-lyse fungi, Gram (+/-) bacteria, algae, and protozoa.",
        "handle": "/products/quick-dna-fungal-bacterial-midiprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6105.jpg",
        "generalIndex": "29",
        "id": "quick-dna-fungal-bacterial-midiprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "yeast-fungi",
          "high-sample-input",
          "physical-lysis",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA Fungal/Bacterial 96 Kit": {
        "title": "<i>Quick</i>-DNA Fungal/Bacterial 96 Kit",
        "catalogNumbers": "D6006",
        "description": "Simple high-throughput isolation of ultra-pure DNA from tough-to-lyse fungi, Gram (+/-) bacteria, algae, and protozoa.",
        "handle": "/products/quick-dna-fungal-bacterial-96-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6006.jpg",
        "generalIndex": "30",
        "id": "quick-dna-fungal-bacterial-96-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "yeast-fungi",
          "high-throughput",
          "automated-high-throughput",
          "physical-lysis",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 5
          // }
        ]
      },
      "ZymoBIOMICS DNA Miniprep Kit": {
        "title": "ZymoBIOMICS DNA Miniprep Kit",
        "catalogNumbers": "D4300, D4300T, D4304",
        "description": "Efficient microbial DNA purification from a variety of sample inputs for highly accurate microbiome and metagenome analyses.",
        "handle": "/products/zymobiomics-dna-miniprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4300T.jpg",
        "generalIndex": "24",
        "id": "zymobiomics-dna-miniprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "blood",
          "tissue",
          "feces",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "soil-and-water",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "microbiome-metagenome-analysis",
          "physical-lysis",
          "spin-columns",
          "cells",
          "certified-low-bioburden"
        ],
        "filters": []
      },
      "ZymoBIOMICS Microprep Kit (Lysis Tubes)": {
        "title": "ZymoBIOMICS DNA Microprep Kit",
        "catalogNumbers": "D4301, D4305",
        "description": "Efficient microbial DNA purification from low sample inputs for highly accurate microbiome and metagenome analyses.",
        "handle": "/products/zymobiomics-dna-microprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4301.jpg",
        "generalIndex": "23",
        "id": "zymobiomics-dna-microprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "blood",
          "tissue",
          "feces",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "soil-and-water",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "low-sample-input",
          "microbiome-metagenome-analysis",
          "physical-lysis",
          "spin-columns",
          "cells",
          "certified-low-bioburden"
        ],
        "filters": []
      },
      "ZymoBIOMICS 96 MagBead DNA Kit": {
        "title": "ZymoBIOMICS 96 MagBead DNA Kit",
        "catalogNumbers": "D4302, D4302-E, D4306, D4306-E, D4308, D4308-E",
        "description": "Automatable solution for microbial DNA purification from a variety of sample inputs for highly accurate microbiome and metagenome analyses.",
        "handle": "/products/zymobiomics-96-magbead-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4302.jpg",
        "generalIndex": "26",
        "id": "zymobiomics-96-magbead-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "blood",
          "tissue",
          "feces",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "soil-and-water",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "ce-ivd",
          "high-throughput",
          "automated-high-throughput",
          "microbiome-metagenome-analysis",
          "physical-lysis",
          "magnetic-beads-automatable",
          "cells",
          "certified-low-bioburden"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 4
          // }
        ]
      },
      "ZymoBIOMICS 96 DNA Kit": {
        "title": "ZymoBIOMICS 96 DNA Kit",
        "catalogNumbers": "D4303, D4307, D4309",
        "description": "High-throughput microbial DNA purification from a variety of sample inputs for highly accurate microbiome and metagenome analyses.",
        "handle": "/products/zymobiomics-96-dna-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4303.jpg",
        "generalIndex": "25",
        "id": "zymobiomics-96-dna-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "blood",
          "tissue",
          "feces",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "soil-and-water",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "high-throughput",
          "automated-high-throughput",
          "microbiome-metagenome-analysis",
          "physical-lysis",
          "96-well-plate",
          "cells",
          "certified-low-bioburden"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 3
          // }
        ]
      },
      "Quick-DNA Fecal/Soil Microbe DNA Miniprep Kit": {
        "title": "<i>Quick</i>-DNA Fecal/Soil Microbe Miniprep Kit",
        "catalogNumbers": "D6010",
        "description": "Robust spin-column extraction of ultra-pure total microbial DNA from up to 150 mg of feces or 250 mg of soil.",
        "handle": "/products/quick-dna-fecal-soil-microbe-dna-miniprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6010.jpg",
        "generalIndex": "32",
        "id": "quick-dna-fecal-soil-microbe-dna-miniprep-kit",
        "tags": [
          "bacteria",
          "feces",
          "soil-and-water",
          "virus",
          "yeast-fungi",
          "physical-lysis",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA Fecal/Soil Microbe Microprep": {
        "title": "<i>Quick</i>-DNA Fecal/Soil Microbe Microprep Kit",
        "catalogNumbers": "D6012",
        "description": "Robust spin-column extraction of ultra-pure total microbial DNA from up to 50 mg of feces or 250 mg of soil.",
        "handle": "/products/quick-dna-fecal-soil-microbe-microprep",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6012.jpg",
        "generalIndex": "31",
        "id": "quick-dna-fecal-soil-microbe-microprep",
        "tags": [
          "bacteria",
          "feces",
          "soil-and-water",
          "virus",
          "yeast-fungi",
          "low-sample-input",
          "physical-lysis",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA Fecal/Soil Microbe 96 Magbead Kit": {
        "title": "<i>Quick</i>-DNA Fecal/Soil Microbe 96 Magbead Kit",
        "catalogNumbers": "D6010-FM, D6011-FM, D6012-FM",
        "description": "Robust automatable extraction of ultra-pure total microbial DNA from up to 100 mg of feces or 200 mg of soil.",
        "handle": "/products/quick-dna-fecal-soil-microbe-96-magbead-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6011_FM.jpg",
        "generalIndex": "35",
        "id": "quick-dna-fecal-soil-microbe-96-magbead-kit",
        "tags": [
          "bacteria",
          "feces",
          "soil-and-water",
          "virus",
          "yeast-fungi",
          "high-throughput",
          "automated-high-throughput",
          "physical-lysis",
          "magnetic-beads-automatable"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 7
          // }
        ]
      },
      "Quick-DNA Fecal/Soil Microbe 96 Kit": {
        "title": "<i>Quick</i>-DNA Fecal/Soil Microbe 96 Kit",
        "catalogNumbers": "D6011",
        "description": "Robust high-throughput extraction of ultra-pure total microbial DNA from up to 80 mg of feces or 135 mg of soil.",
        "handle": "/products/quick-dna-fecal-soil-microbe-96-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6011.jpg",
        "generalIndex": "34",
        "id": "quick-dna-fecal-soil-microbe-96-kit",
        "tags": [
          "bacteria",
          "feces",
          "soil-and-water",
          "virus",
          "yeast-fungi",
          "high-throughput",
          "automated-high-throughput",
          "physical-lysis",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 6
          // }
        ]
      },
      "Quick-DNA Fecal/Soil Microbe Midiprep": {
        "title": "<i>Quick</i>-DNA Fecal/Soil Microbe Midiprep Kit",
        "catalogNumbers": "D6110",
        "description": "Robust spin-column extraction of ultra-pure total microbial DNA from up to 375 mg of feces or 5 grams of soil.",
        "handle": "/products/quick-dna-fecal-soil-microbe-midiprep",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6110.jpg",
        "generalIndex": "33",
        "id": "quick-dna-fecal-soil-microbe-midiprep",
        "tags": [
          "bacteria",
          "feces",
          "soil-and-water",
          "virus",
          "yeast-fungi",
          "physical-lysis",
          "spin-columns",
          "high-sample-input"
        ],
        "filters": []
      },
      "Quick-DNA Miniprep": {
        "title": "<i>Quick</i>-DNA Miniprep Kit",
        "catalogNumbers": "D3024, D3025",
        "description": "Fast and easy Proteinase K-free extraction of ultra-pure total DNA from up to 200 µl of blood or 5 x 10^6 cells.",
        "handle": "/products/quick-dna-miniprep",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3024.jpg",
        "generalIndex": "54",
        "id": "quick-dna-miniprep",
        "tags": [
          "cells",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "virus",
          "hmw-dna",
          "spin-columns",
          "swabs-and-saliva",
          "blood"
        ],
        "filters": []
      },
      "Quick-DNA Microprep Kit": {
        "title": "<i>Quick</i>-DNA Microprep Kit",
        "catalogNumbers": "D3020, D3021",
        "description": "Fast and easy Proteinase K-free extraction of ultra-pure total DNA from up to 50 µl of blood or 1 x 10^6 cells.",
        "handle": "/products/quick-dna-microprep",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3021.jpg",
        "generalIndex": "53",
        "id": "quick-dna-microprep",
        "tags": [
          "cells",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "virus",
          "low-sample-input",
          "hmw-dna",
          "spin-columns",
          "swabs-and-saliva",
          "blood"
        ],
        "filters": []
      },
      "Quick-DNA 96 Kit": {
        "title": "<i>Quick</i>-DNA 96 Kit",
        "catalogNumbers": "D3010, D3011, D3012",
        "description": "High-throughput Proteinase K-free extraction of ultra-pure total DNA from 50 µl of blood or 1 x 10^6 cells.",
        "handle": "/products/quick-dna-96-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3012.jpg",
        "generalIndex": "55",
        "id": "quick-dna-96-kit",
        "tags": [
          "cells",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "virus",
          "high-throughput",
          "automated-high-throughput",
          "hmw-dna",
          "96-well-plate",
          "swabs-and-saliva",
          "blood"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 2
          // }
        ]
      },
      "Quick-DNA Tissue/Insect Microprep Kit": {
        "title": "<i>Quick</i>-DNA Tissue/Insect Microprep Kit",
        "catalogNumbers": "D6015",
        "description": "Simply extract high quality DNA from up to 10 mg of tissue or insect specimens using rapid spin-column purification.",
        "handle": "/products/quick-dna-tissue-insect-microprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6015.jpg",
        "generalIndex": "46",
        "id": "quick-dna-tissue-insect-microprep-kit",
        "tags": [
          "tissue",
          "insect",
          "virus",
          "low-sample-input",
          "physical-lysis",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA Tissue/Insect Miniprep Kit": {
        "title": "<i>Quick</i>-DNA Tissue/Insect Miniprep Kit",
        "catalogNumbers": "D6016",
        "description": "Simply extract high quality DNA from up to 50 mg of tissue or insect specimens using rapid spin-column purification.",
        "handle": "/products/quick-dna-tissue-insect-miniprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6016.jpg",
        "generalIndex": "47",
        "id": "quick-dna-tissue-insect-miniprep-kit",
        "tags": [
          "tissue",
          "insect",
          "virus",
          "physical-lysis",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA Tissue/Insect 96 Kit": {
        "title": "<i>Quick</i>-DNA Tissue/Insect 96 Kit",
        "catalogNumbers": "D6017",
        "description": "Simple high-throughput spin-column purification of high quality DNA from up to 10 mg of tissue or insect specimens.",
        "handle": "/products/quick-dna-tissue-insect-96-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/Insect_96_Kit.jpg",
        "generalIndex": "48",
        "id": "quick-dna-tissue-insect-96-kit",
        "tags": [
          "tissue",
          "insect",
          "virus",
          "high-throughput",
          "automated-high-throughput",
          "physical-lysis",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 21
          // }
        ]
      },
      "Quick-DNA Plant/Seed Miniprep Kit": {
        "title": "<i>Quick</i>-DNA Plant/Seed Miniprep Kit",
        "catalogNumbers": "D6020",
        "description": "Efficiently recover high-quality DNA free of PCR inhibitors from tough-to-lyse plant and seed samples.",
        "handle": "/products/quick-dna-plant-seed-miniprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6020.jpg",
        "generalIndex": "44",
        "id": "quick-dna-plant-seed-miniprep-kit",
        "tags": [
          "plant-seed",
          "physical-lysis",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA Plant/Seed 96 Kit": {
        "title": "<i>Quick</i>-DNA Plant/Seed 96 Kit",
        "catalogNumbers": "D6021",
        "description": "High-throughput isolation of high-quality DNA free of PCR inhibitors from tough-to-lyse plant and seed samples.",
        "handle": "/products/quick-dna-plant-seed-96-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6021.jpg",
        "generalIndex": "45",
        "id": "quick-dna-plant-seed-96-kit",
        "tags": [
          "plant-seed",
          "high-throughput",
          "automated-high-throughput",
          "physical-lysis",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 22
          // }
        ]
      },
      "MAGicBead cfDNA Isolation Kit": {
        "title": "MAGicBead cfDNA Isolation Kit",
        "catalogNumbers": "D4086, D4086-custom",
        "description": "Unique, magnetic bead surface chemistry that facilitates unparalleled cfDNA recovery from biofluids.",
        "handle": "/products/magicbead-cfdna-isolation-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4086.jpg",
        "generalIndex": "36",
        "id": "magicbead-cfdna-isolation-kit",
        "tags": [
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "urine",
          "high-throughput",
          "automated-high-throughput",
          "proteinase-k-included",
          "cell-free-dna",
          "magnetic-beads-automatable"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 9
          // }
        ]
      },
      "Quick-DNA HMW MagBead Kit": {
        "title": "<i>Quick</i>-DNA HMW MagBead Kit",
        "catalogNumbers": "D6060",
        "description": "Extract ultra-pure high molecular weight DNA up to 150 kb from a variety of sample inputs using magnetic beads.",
        "handle": "/products/quick-dna-hmw-magbead-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6060.jpg",
        "generalIndex": "40",
        "id": "quick-dna-hmw-magbead-kit",
        "tags": [
          "blood",
          "cells",
          "tissue",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "high-throughput",
          "automated-high-throughput",
          "proteinase-k-included",
          "hmw-dna",
          "magnetic-beads-automatable"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 19
          // }
        ]
      },
      "Genomic DNA Clean & Concentrator-10": {
        "title": "Genomic DNA Clean & Concentrator-10",
        "catalogNumbers": "D4010, D4011",
        "description": "Purify up to 10 µg of ultra-pure high molecular weight DNA from any enzymatic reaction or impure preparation using a simple spin-column protocol.",
        "handle": "/products/genomic-dna-clean-concentrator-10",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4011_b.webp",
        "generalIndex": "37",
        "id": "genomic-dna-clean-concentrator-10",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "crude-extracts-and-purified-dna-or-rna",
          "hmw-dna",
          "spin-columns"
        ],
        "filters": []
      },
      "Genomic DNA Clean & Concentrator-25": {
        "title": "Genomic DNA Clean & Concentrator-25",
        "catalogNumbers": "D4064, D4065",
        "description": "Purify up to 25 µg of ultra-pure high molecular weight DNA from any enzymatic reaction or impure preparation using a simple spin-column protocol.",
        "handle": "/products/genomic-dna-clean-concentrator-25",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4064.webp",
        "generalIndex": "38",
        "id": "genomic-dna-clean-concentrator-25",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "crude-extracts-and-purified-dna-or-rna",
          "hmw-dna",
          "spin-columns"
        ],
        "filters": []
      },
      "Oligo Clean & Concentrator": {
        "title": "Oligo Clean & Concentrator",
        "catalogNumbers": "D4060, D4061",
        "description": "Rapidly recover up to 10 µg of highly concentrated DNA or RNA oligos from labeling and other enzymatic reactions.",
        "handle": "/products/oligo-clean-concentrator",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4060.webp",
        "generalIndex": "41",
        "id": "oligo-clean-concentrator",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "total-nucleic-acid-dna-rna-purification",
          "spin-columns"
        ],
        "filters": []
      },
      "Select-a-Size DNA Clean & Concentrator Kit": {
        "title": "Select-a-Size DNA Clean & Concentrator Kit",
        "catalogNumbers": "D4080",
        "description": "Recover a specific size range of ultra-pure DNA fragments from library preps, PCR, and ligations using a quick spin-column protocol.",
        "handle": "/products/select-a-size-dna-clean-concentrator-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4080.webp",
        "generalIndex": "64",
        "id": "select-a-size-dna-clean-concentrator-kit",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "crude-extracts-and-purified-dna-or-rna",
          "spin-columns"
        ],
        "filters": []
      },
      "Select-a-Size DNA Clean & Concentrator Magbead Kit": {
        "title": "Select-a-Size DNA Clean & Concentrator Magbead Kit",
        "catalogNumbers": "D4084, D4085",
        "description": "Recover a specific size range of ultra-pure DNA fragments from library preps, PCR, and ligations using magnetic beads.",
        "handle": "/products/select-a-size-dna-clean-concentrator-magbead-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4084.webp",
        "generalIndex": "65",
        "id": "select-a-size-dna-clean-concentrator-magbead-kit",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "crude-extracts-and-purified-dna-or-rna",
          "high-throughput",
          "automated-high-throughput",
          "magnetic-beads-automatable"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 26
          // }
        ]
      },
      "Quick-DNA Viral Kit": {
        "title": "<i>Quick</i>-DNA Viral Kit",
        "catalogNumbers": "D3015, D3016",
        "description": "Quickly recover highly concentrated ultra-pure viral DNA from a wide range of sample types.",
        "handle": "/products/quick-dna-viral-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3015.jpg",
        "generalIndex": "50",
        "id": "quick-dna-viral-kit",
        "tags": [
          "blood",
          "cells",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "virus",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA Viral 96 Kit": {
        "title": "<i>Quick</i>-DNA Viral 96 Kit",
        "catalogNumbers": "D3017, D3018",
        "description": "High-throughput extraction of highly concentrated ultra-pure viral DNA from a wide range of sample types.",
        "handle": "/products/quick-dna-viral-96-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3017.jpg",
        "generalIndex": "51",
        "id": "quick-dna-viral-96-kit",
        "tags": [
          "blood",
          "cells",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "virus",
          "high-throughput",
          "automated-high-throughput",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 20
          // }
        ]
      },
      "Quick-DNA Urine Kit": {
        "title": "<i>Quick</i>-DNA Urine Kit",
        "catalogNumbers": "D3061",
        "description": "Easily extract high quality cell-free or cellular DNA from up to 40 ml of urine using spin-column purification.",
        "handle": "/products/quick-dna-urine-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3061.jpg",
        "generalIndex": "49",
        "id": "quick-dna-urine-kit",
        "tags": [
          "urine",
          "virus",
          "cell-free-dna",
          "spin-columns"
        ],
        "filters": [
          {
            "filter": "urine",
            "index": 1
          }
        ]
      },
      "Quick-DNA FFPE Miniprep": {
        "title": "<i>Quick</i>-DNA FFPE Miniprep Kit",
        "catalogNumbers": "D3067",
        "description": "Isolate ultra-pure DNA from FFPE tissue with an optimized and fast spin-column protocol.",
        "handle": "/products/quick-dna-ffpe-miniprep",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3067.jpg",
        "generalIndex": "43",
        "id": "quick-dna-ffpe-miniprep",
        "tags": [
          "ffpe",
          "proteinase-k-included",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-cfDNA Serum & Plasma Kit": {
        "title": "<i>Quick</i>-cfDNA Serum & Plasma Kit",
        "catalogNumbers": "D4076",
        "description": "Reliably extract high-quality circulating cell-free DNA from serum, plasma, amniotic fluid, cerebrospinal fluid (CSF), and saliva.",
        "handle": "/products/quick-cfdna-serum-plasma-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4076.jpg",
        "generalIndex": "52",
        "id": "quick-cfdna-serum-plasma-kit",
        "tags": [
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "proteinase-k-included",
          "cell-free-dna",
          "spin-columns"
        ],
        "filters": []
      },
      "Zyppy Plasmid Miniprep Kit": {
        "title": "Zyppy Plasmid Miniprep Kit",
        "catalogNumbers": "D4019, D4020, D4036, D4037",
        "description": "Purify ultra-pure plasmid DNA from 600 µl of overnight <i>E. coli</i> culture without pelleting cells.",
        "handle": "/products/zyppy-plasmid-miniprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4019.webp",
        "generalIndex": "56",
        "id": "zyppy-plasmid-miniprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "plasmid-purification",
          "spin-columns"
        ],
        "filters": []
      },
      "Zyppy-96 Plasmid Kit": {
        "title": "Zyppy-96 Plasmid Kit",
        "catalogNumbers": "D4041, D4042, D4043",
        "description": "High-throughput purification of ultra-pure plasmid DNA from 750 µl of overnight <i>E. coli</i> culture without pelleting cells.",
        "handle": "/products/zyppy-96-plasmid-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4041.webp",
        "generalIndex": "57",
        "id": "zyppy-96-plasmid-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "high-throughput",
          "automated-high-throughput",
          "plasmid-purification",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 16
          // }
        ]
      },
      "Zyppy-96 Plasmid MagBead Miniprep": {
        "title": "Zyppy-96 Plasmid MagBead Miniprep Kit",
        "catalogNumbers": "D4100, D4101, D4102",
        "description": "Automatable purification of ultra-pure plasmid DNA from 750 µl of overnight <i>E. coli</i> culture without pelleting cells.",
        "handle": "/products/zyppy-96-plasmid-magbead-kit",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4100_Zyppy-96-Plasmid-MagBead-Miniprep.png?v=1628532412&width=600",
        "generalIndex": "58",
        "id": "zyppy-96-plasmid-magbead-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "high-throughput",
          "automated-high-throughput",
          "plasmid-purification",
          "magnetic-beads-automatable"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 17
          // }
        ]
      },
      "Zymoprep Yeast Plasmid Miniprep I": {
        "title": "Zymoprep Yeast Plasmid Miniprep I",
        "catalogNumbers": "D2001",
        "description": "Simple plasmid DNA isolation by isopropanol precipitation from yeast cultures using Zymolyase and alkaline lysis.",
        "handle": "/products/zymoprep-yeast-plasmid-miniprep-i",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit_8b5581ce-6473-43b0-951d-d8f0a01bd259.jpg?v=1628532359&width=600",
        "generalIndex": "59",
        "id": "zymoprep-yeast-plasmid-miniprep-i",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "yeast-fungi",
          "plasmid-purification",
          "spin-columns"
        ],
        "filters": []
      },
      "Zymoprep Yeast Plasmid Miniprep II": {
        "title": "Zymoprep Yeast Plasmid Miniprep II",
        "catalogNumbers": "D2004",
        "description": "Quick spin-column purification of plasmid DNA from yeast cultures using Zymolyase and alkaline lysis.",
        "handle": "/products/zymoprep-yeast-plasmid-miniprep-ii",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D2004_Zymoprep-Yeast-Plasmid-MiniPrep-II-Kit_aabbe60a-e5fb-44a8-b7b4-722047f23e24.jpg?v=1628532377&width=600",
        "generalIndex": "60",
        "id": "zymoprep-yeast-plasmid-miniprep-ii",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "yeast-fungi",
          "plasmid-purification",
          "spin-columns"
        ],
        "filters": []
      },
      "Zymoprep-96 Yeast Plasmid Miniprep": {
        "title": "Zymoprep-96 Yeast Plasmid Miniprep Kit",
        "catalogNumbers": "D2005, D2006, D2007",
        "description": "Easy high-throughput spin-column purification of plasmid DNA from yeast cultures using Zymolyase and alkaline lysis.",
        "handle": "/products/zymoprep-96-yeast-plasmid-miniprep",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D2007_Zymoprep-96-Yeast-Plasmid-Miniprep-Kit_815aae83-fc83-4806-8e72-654cdf122053.jpg?v=1628532360&width=600",
        "generalIndex": "61",
        "id": "zymoprep-96-yeast-plasmid-miniprep",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "yeast-fungi",
          "high-throughput",
          "automated-high-throughput",
          "plasmid-purification",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 18
          // }
        ]
      },
      "ZR Plasmid Miniprep - Classic": {
        "title": "ZR Plasmid Miniprep - Classic",
        "catalogNumbers": "D4015, D4016, D4054",
        "description": "Easily purify ultra-pure plasmid DNA from up to 5 ml of overnight <i>E. coli</i> culture using a traditional alkaline lysis spin-column protocol.",
        "handle": "/products/zr-plasmid-miniprep-classic",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4015_ZR-Plasmid-Miniprep-Classic-Kit.jpg?v=1628532396&width=600",
        "generalIndex": "62",
        "id": "zr-plasmid-miniprep-classic",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "plasmid-purification",
          "spin-columns"
        ],
        "filters": []
      },
      "ZR BAC DNA Miniprep Kit": {
        "title": "ZR BAC DNA Miniprep Kit",
        "catalogNumbers": "D4048, D4049",
        "description": "Quickly isolate large constructs (≤ 200 kb) from up to 5 ml of overnight <i>E. coli</i> culture using a spin-column.",
        "handle": "/products/zr-bac-dna-miniprep-kit",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4048_ZR-BAC-DNA-Miniprep-Kit.jpg?v=1628532399&width=600",
        "generalIndex": "63",
        "id": "zr-bac-dna-miniprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "plasmid-purification",
          "spin-columns"
        ],
        "filters": []
      },
      "Zymoclean Large Fragment DNA Recovery": {
        "title": "Zymoclean Large Fragment DNA Recovery",
        "catalogNumbers": "D4045, D4046",
        "description": "Simple and quick isolation of ultra-pure high molecular weight DNA from TAE/TBE buffered agarose gels.",
        "handle": "/products/zymoclean-large-fragment-dna-recovery",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4045.webp",
        "generalIndex": "68",
        "id": "zymoclean-large-fragment-dna-recovery",
        "tags": [
          "agarose-gel",
          "reaction-products-and-aqueous-phase",
          "spin-columns"
        ],
        "filters": []
      },
      "Pinpoint Slide DNA Isolation": {
        "title": "Pinpoint Slide DNA Isolation System",
        "catalogNumbers": "D3001",
        "description": "Streamlined isolation of ultra-pure DNA from specific regions of fresh and FFPE tissue slides.",
        "handle": "/products/pinpoint-slide-dna-isolation-system",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3001.jpg",
        "generalIndex": "66",
        "id": "pinpoint-slide-dna-isolation-system",
        "tags": [
          "slide",
          "ffpe",
          "spin-columns"
        ],
        "filters": []
      },
      "HostZero Microbial DNA Kit": {
        "title": "HostZero Microbial DNA Kit",
        "catalogNumbers": "D4310",
        "description": "Effective host DNA depletion and total microbial DNA isolation from mammalian samples using a simple spin-column process.",
        "handle": "/products/hostzero-microbial-dna-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4310.jpg",
        "generalIndex": "67",
        "id": "hostzero-microbial-dna-kit",
        "tags": [
          "bacteria",
          "blood",
          "tissue",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "yeast-fungi",
          "proteinase-k-included",
          "physical-lysis",
          "spin-columns",
          "certified-low-bioburden",
          "host-dna-depletion"
        ],
        "filters": []
      },
      "YeaStar Genomic DNA Kit": {
        "title": "YeaStar Genomic DNA Kit",
        "catalogNumbers": "D2002",
        "description": "Reliable and efficient isolation of genomic DNA from a broad spectrum of fungal species using Zymolyase.",
        "handle": "/products/yeastar-genomic-dna-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D2002.jpg",
        "generalIndex": "69",
        "id": "yeastar-genomic-dna-kit",
        "tags": [
          "microbial-cultures",
          "yeast-fungi",
          "spin-columns"
        ],
        "filters": []
      },
      "EZ Nucleosomal DNA Prep Kit": {
        "title": "EZ Nucleosomal DNA Prep Kit",
        "catalogNumbers": "D5220",
        "description": "Streamlined and optimized method for isolating nucleosome-associated DNA.",
        "handle": "/products/ez-nucleosomal-dna-prep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D5220.jpg",
        "generalIndex": "70",
        "id": "ez-nucleosomal-dna-prep-kit",
        "tags": [
          "microbial-cultures",
          "cells",
          "yeast-fungi",
          "nucleosomal-dna-isolation",
          "spin-columns"
        ],
        "filters": []
      },
      "ChIP DNA Clean & Concentrator": {
        "title": "ChIP DNA Clean & Concentrator",
        "catalogNumbers": "D5201, D5205",
        "description": "Easily recover ultra-pure DNA from any step in a standard ChIP protocol using spin-column purification.",
        "handle": "/products/chip-dna-clean-concentrator",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5201_ChIP-DNA-Clean-and-Concentrator-Kit.jpg?v=1628532405&width=600",
        "generalIndex": "71",
        "id": "chip-dna-clean-concentrator",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "spin-columns"
        ],
        "filters": []
      },
      "ZR-96 ChIP DNA Clean & Concentrator": {
        "title": "ZR-96 ChIP DNA Clean & Concentrator Kit",
        "catalogNumbers": "D5206, D5207",
        "description": "High-throughput recovery of ultra-pure DNA from any step in a standard ChIP protocol using rapid spin-column purification.",
        "handle": "/products/zr-96-chip-dna-clean-concentrator",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5206_ZR-96-ChIP-DNA-Clean-and-Concentrator-Kit.jpg?v=1628532406&width=600",
        "generalIndex": "72",
        "id": "zr-96-chip-dna-clean-concentrator",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "high-throughput",
          "automated-high-throughput",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 25
          // }
        ]
      },
      "ssDNA/RNA Clean & Concentrator": {
        "title": "ssDNA/RNA Clean & Concentrator",
        "catalogNumbers": "D7010, D7011",
        "description": "Easily purify up to 10 µg of highly concentrated single stranded DNA or RNA from samples containing double stranded DNA.",
        "handle": "/products/ssdna-rna-clean-concentrator",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D7010_ssDNA-RNA-Clean-and-Concentrator-Kit_15e63804-98d4-4820-973a-01c4d951f139.jpg?v=1628532354&width=600",
        "generalIndex": "73",
        "id": "ssdna-rna-clean-concentrator",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "crude-extracts-and-purified-dna-or-rna",
          "total-nucleic-acid-dna-rna-purification",
          "spin-columns"
        ],
        "filters": []
      },
      "ZR DNA Sequencing Clean-Up Kit": {
        "title": "ZR DNA Sequencing Clean-Up Kit",
        "catalogNumbers": "D4050, D4051",
        "description": "Efficiently clean up dye terminator sequencing reactions prior to Sanger Sequencing in just 2 minutes.",
        "handle": "/products/zr-dna-sequencing-clean-up-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4050.webp",
        "generalIndex": "74",
        "id": "zr-dna-sequencing-clean-up-kit",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "spin-columns"
        ],
        "filters": []
      },
      "ZR-96 DNA Clean-Up Kit (Shallow Well)": {
        "title": "ZR-96 DNA Clean-Up Kit (Shallow Well)",
        "catalogNumbers": "D4017, D4018",
        "description": "High-throughput purification of up to 5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources using a low-profile spin-plate.",
        "handle": "/products/zr-96-dna-clean-up-kit",
        "navigation_image": "https://www.zymoresearch.com/cdn/shop/products/D4017_ZR-96-DNA-Clean-up-Kit_1200x.jpg",
        "generalIndex": "16",
        "id": "zr-96-dna-clean-up-kit",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "crude-extracts-and-purified-dna-or-rna",
          "high-throughput",
          "automated-high-throughput",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 10
          // }
        ]
      },
      "ZR-96 DNA Clean & Concentrator-5": {
        "title": "ZR-96 DNA Clean & Concentrator-5 Kit",
        "catalogNumbers": "D4023, D4024",
        "description": "High-throughput purification of up to 5 µg of highly concentrated ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
        "handle": "/products/zr-96-dna-clean-amp-concentrator-5-deep-well",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4023.webp",
        "generalIndex": "17",
        "id": "zr-96-dna-clean-amp-concentrator-5-deep-well",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "crude-extracts-and-purified-dna-or-rna",
          "high-throughput",
          "automated-high-throughput",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 11
          // }
        ]
      },
      "ZR-96 Genomic DNA Clean & Concentrator-5 Kit": {
        "title": "ZR-96 Genomic DNA Clean & Concentrator-5 Kit",
        "catalogNumbers": "D4066, D4067",
        "description": "High-throughput purification of up to 5 µg of ultra-pure high molecular weight DNA from any enzymatic reaction or impure preparation.",
        "handle": "/products/zr-96-genomic-dna-clean-concentrator-5-kit",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4066_ZR-96-Genomic-DNA-Clean-and-Concentrator-5-Kit.jpg?v=1628532355&width=600",
        "generalIndex": "39",
        "id": "zr-96-genomic-dna-clean-concentrator-5-kit",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "crude-extracts-and-purified-dna-or-rna",
          "high-throughput",
          "automated-high-throughput",
          "hmw-dna",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 12
          // }
        ]
      },
      "ZR-96 Oligo Clean & Concentrator": {
        "title": "ZR-96 Oligo Clean & Concentrator Kit",
        "catalogNumbers": "D4062, D4063",
        "description": "High-throughput purification of up to 10 µg of highly concentrated DNA or RNA oligos from labeling and other enzymatic reactions.",
        "handle": "/products/oligo-clean-concentrator-zr96",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4062_ZR-96-Oligo-Clean-Concentrator.png?v=1628532356&width=600",
        "generalIndex": "42",
        "id": "oligo-clean-concentrator-zr96",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "high-throughput",
          "automated-high-throughput",
          "total-nucleic-acid-dna-rna-purification",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 23
          // }
        ]
      },
      "ZR-96 DNA Sequencing Clean-up Kit": {
        "title": "ZR-96 DNA Sequencing Clean-up Kit",
        "catalogNumbers": "D4052, D4053",
        "description": "High-throughput and rapid clean up of dye terminator sequencing reactions prior to Sanger Sequencing.",
        "handle": "/products/zr-96-dna-sequencing-clean-up-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4052.webp",
        "generalIndex": "75",
        "id": "zr-96-dna-sequencing-clean-up-kit",
        "tags": [
          "reaction-products-and-aqueous-phase",
          "high-throughput",
          "automated-high-throughput",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 24
          // }
        ]
      },
      "ZR-96 Zymoclean Gel DNA Recovery Kit": {
        "title": "ZR-96 Zymoclean Gel DNA Recovery Kit",
        "catalogNumbers": "D4021, D4022",
        "description": "High-throughput purification of highly concentrated ultra-pure DNA from TAE/TBE buffered agarose gels.",
        "handle": "/products/zr-96-zymoclean-gel-dna-recovery-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4021.webp",
        "generalIndex": "20",
        "id": "zymoclean-large-fragment-dna-recovery",
        "tags": [
          "agarose-gel",
          "reaction-products-and-aqueous-phase",
          "high-throughput",
          "automated-high-throughput",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 14
          // }
        ]
      },
      "Quick-DNA/RNA Microprep Plus Kit": {
        "title": "<i>Quick</i>-DNA/RNA Microprep Plus Kit",
        "catalogNumbers": "D7005, D7005T",
        "description": "Combines the <i>Quick</i>-DNA/RNA technology with DNA/RNA Shield and Proteinase K to enable easy, reliable isolation of ≤ 5 µg DNA and ≤ 10 µg RNA from biological samples including cells, solid tissue, and whole blood.",
        "handle": "/products/quick-dna-rna-microprep-plus-kit",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D7005_Quick-DNA-RNA-Microprep-Plus-Kit.jpg?v=1628532359&width=600",
        "generalIndex": "76",
        "id": "quick-dna-rna-microprep-plus-kit",
        "tags": [
          "microbial-cultures",
          "all-purpose-extraction",
          "bacteria",
          "blood",
          "cells",
          "tissue",
          "insect",
          "plant-seed",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "storage-papers-hair-feather-nails",
          "low-sample-input",
          "proteinase-k-included",
          "total-nucleic-acid-dna-rna-purification",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA/RNA Miniprep": {
        "title": "<i>Quick</i>-DNA/RNA Miniprep Kit",
        "catalogNumbers": "D7001",
        "description": "Provides a quick method for the isolation of high quality genomic DNA (up to 100 µg) and total RNA (up to 50 µg) from small amounts of cells and tissue without the use of phenol.",
        "handle": "/products/quick-dna-rna-miniprep",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D7001_Quick-DNA-RNA-Miniprep-Kit.jpg?v=1628532357&width=600",
        "generalIndex": "77",
        "id": "quick-dna-rna-miniprep",
        "tags": [
          "microbial-cultures",
          "all-purpose-extraction",
          "bacteria",
          "blood",
          "cells",
          "tissue",
          "insect",
          "plant-seed",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "total-nucleic-acid-dna-rna-purification",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA/RNA Miniprep Plus Kit": {
        "title": "<i>Quick</i>-DNA/RNA Miniprep Plus Kit",
        "catalogNumbers": "D7003, D7003T",
        "description": "Combines the <i>Quick</i>-DNA/RNA technology with DNA/RNA Shield, a unique preservation and lysis technology, and Proteinase K to enable easy, reliable isolation from biological samples including cells, solid tissue, and whole blood.",
        "handle": "/products/quick-dna-rna-miniprep-plus-kit",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D7003_ZR-Duet-DNA-RNA-MiniPrep-Plus-Kit.jpg?v=1628532377&width=600",
        "generalIndex": "78",
        "id": "quick-dna-rna-miniprep-plus-kit",
        "tags": [
          "microbial-cultures",
          "all-purpose-extraction",
          "bacteria",
          "blood",
          "cells",
          "tissue",
          "insect",
          "plant-seed",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "storage-papers-hair-feather-nails",
          "proteinase-k-included",
          "total-nucleic-acid-dna-rna-purification",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA/RNA MagBead": {
        "title": "<i>Quick</i>-DNA/RNA MagBead Kit",
        "catalogNumbers": "R2130, R2131",
        "description": "A high-thoughput, magnetic bead-based purification of both high-quality DNA and total RNA (including small/microRNAs) from the same starting sample.",
        "handle": "/products/quick-dna-rna-magbead",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2131-Quick-DNA-RNA-MagBead_9dd3abe5-e804-44ff-9faf-01cb95f36312.jpg?v=1628532371&width=600",
        "generalIndex": "79",
        "id": "quick-dna-rna-magbead",
        "tags": [
          "microbial-cultures",
          "all-purpose-extraction",
          "bacteria",
          "blood",
          "cells",
          "tissue",
          "insect",
          "plant-seed",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "storage-papers-hair-feather-nails",
          "high-throughput",
          "automated-high-throughput",
          "proteinase-k-included",
          "total-nucleic-acid-dna-rna-purification",
          "magnetic-beads-automatable",
          "ffpe"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 27
          // }
        ]
      },
      "Quick-DNA/RNA Pathogen Miniprep": {
        "title": "<i>Quick</i>-DNA/RNA Pathogen Miniprep Kit",
        "catalogNumbers": "R1042, R1043",
        "description": "A spin-column based purification of pathogen DNA and RNA from a wide variety of vectors and tissue types transported and stored in DNA/RNA Shield.",
        "handle": "/products/quick-dna-rna-pathogen-miniprep",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1042_Quick-DNA-RNA-Pathogen-Miniprep-Kit_3a0a6221-d61f-40c3-8238-fc0261e0371f.jpg?v=1628532367&width=600",
        "generalIndex": "87",
        "id": "quick-dna-rna-pathogen-miniprep",
        "tags": [
          "bacteria",
          "blood",
          "tissue",
          "feces",
          "insect",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "virus",
          "yeast-fungi",
          "proteinase-k-included",
          "total-nucleic-acid-dna-rna-purification",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA/RNA Pathogen MagBead": {
        "title": "<i>Quick</i>-DNA/RNA Pathogen MagBead Kit",
        "catalogNumbers": "R2145, R2146",
        "description": "High-throughput, magnetic bead-based purification of pathogen (virus, bacteria, protozoa) DNA and RNA from a wide variety of vectors (mosquitoes, fleas, ticks, etc.)",
        "handle": "/products/quick-dna-rna-pathogen-magbead",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2145-Quick-DNA-RNA-Pathogen-MagBead.jpg?v=1628532370&width=600",
        "generalIndex": "88",
        "id": "quick-dna-rna-pathogen-magbead",
        "tags": [
          "bacteria",
          "blood",
          "tissue",
          "feces",
          "insect",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "virus",
          "yeast-fungi",
          "high-throughput",
          "automated-high-throughput",
          "proteinase-k-included",
          "total-nucleic-acid-dna-rna-purification",
          "magnetic-beads-automatable"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 28
          // }
        ]
      },
      "Quick-DNA/RNA Blood Tube Kit": {
        "title": "<i>Quick</i>-DNA/RNA Blood Tube Kit",
        "catalogNumbers": "R1151",
        "description": "Co-purify DNA and RNA from the DNA/RNA Shield Blood Collection Tube.",
        "handle": "/products/quick-dna-rna-blood-tube-kit",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/r1151_quick-dna-rna-blood-tube-kit_1.jpg?v=1628532391&width=600",
        "generalIndex": "89",
        "id": "quick-dna-rna-blood-tube-kit",
        "tags": [
          "blood",
          "virus",
          "yeast-fungi",
          "proteinase-k-included",
          "total-nucleic-acid-dna-rna-purification",
          "spin-columns"
        ],
        "filters": []
      },
      "ZymoBIOMICS DNA/RNA Miniprep Kit": {
        "title": "ZymoBIOMICS DNA/RNA Miniprep Kit",
        "catalogNumbers": "R2002",
        "description": "Designed for purifying DNA and RNA from a wide array of sample inputs (e.g., feces, soil, plant, water, and biofilms). Ready for RT-PCR, arrays, sequencing, microbiome, or metagenome analysis.",
        "handle": "/products/zymobiomics-dna-rna-miniprep-kit",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg?v=1628532356&width=600",
        "generalIndex": "85",
        "id": "zymobiomics-dna-rna-miniprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "blood",
          "tissue",
          "feces",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "soil-and-water",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "microbiome-metagenome-analysis",
          "physical-lysis",
          "total-nucleic-acid-dna-rna-purification",
          "spin-columns",
          "cells",
          "certified-low-bioburden"
        ],
        "filters": []
      },
      "ZymoBIOMICS MagBead DNA/RNA": {
        "title": "ZymoBIOMICS MagBead DNA/RNA Kit",
        "catalogNumbers": "R2135, R2136",
        "description": "A high-throughput, magnetic bead-based microbiome extraction kit designed for microbial DNA and RNA purification.",
        "handle": "/products/zymobiomics-magbead-dna-rna",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/r2135_zymobiomics_96_magbead_dna_rna_kit.png?v=1628532421&width=600",
        "generalIndex": "86",
        "id": "zymobiomics-magbead-dna-rna",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "blood",
          "tissue",
          "feces",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "soil-and-water",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "high-throughput",
          "microbiome-metagenome-analysis",
          "proteinase-k-included",
          "physical-lysis",
          "total-nucleic-acid-dna-rna-purification",
          "magnetic-beads-automatable",
          "cells",
          "certified-low-bioburden"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 29
          // }
        ]
      },
      "Quick-DNA/RNA Viral Kit": {
        "title": "<i>Quick</i>-DNA/RNA Viral Kit",
        "catalogNumbers": "D7020, D7021",
        "description": "A fast viral DNA/RNA purification kit for viral DNA and RNA from plasma, serum, cell culture media, cellular suspensions, urine, blood, saliva, and any other biological samples stored in DNA/RNA Shield.",
        "handle": "/products/quick-dna-rna-viral-kit",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D7020_Quick-DNA-RNA-Viral-Kit.jpg?v=1628532365&width=600",
        "generalIndex": "80",
        "id": "quick-dna-rna-viral-kit",
        "tags": [
          "blood",
          "cells",
          "feces",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "total-nucleic-acid-dna-rna-purification",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA/RNA Viral 96 Kit": {
        "title": "<i>Quick</i>-DNA/RNA Viral 96 Kit",
        "catalogNumbers": "D7022, D7023",
        "description": "High-throughput (96-well) isolation of high-quality viral DNA and/or RNA from a wide range of biological sources.",
        "handle": "/products/quick-dna-rna-viral-96-kit",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D7022_ZR-96-Viral-DNA-RNA-kit.jpg?v=1628532355&width=600",
        "generalIndex": "81",
        "id": "quick-dna-rna-viral-96-kit",
        "tags": [
          "blood",
          "cells",
          "feces",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "high-throughput",
          "automated-high-throughput",
          "total-nucleic-acid-dna-rna-purification",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 30
          // }
        ]
      },
      "Quick-DNA/RNA Viral MagBead Kit": {
        "title": "<i>Quick</i>-DNA/RNA Viral MagBead Kit",
        "catalogNumbers": "R2140, R2140-E, R2141, R2141-E",
        "description": "High-throughput, magnetic bead-based purification of viral DNA and/or RNA from plasma, serum, urine, cell culture media, blood, saliva, cellular suspensions, biopsies and swab and fecal samples stored in DNA/RNA Shield.",
        "handle": "/products/quick-dna-rna-viral-magbead",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/r2140-quick-dna-rna-viral-magbead-ce-ivd.jpg?v=1628532376&width=600",
        "generalIndex": "82",
        "id": "quick-dna-rna-viral-magbead",
        "tags": [
          "blood",
          "cells",
          "feces",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "ce-ivd",
          "high-throughput",
          "automated-high-throughput",
          "proteinase-k-included",
          "total-nucleic-acid-dna-rna-purification",
          "magnetic-beads-automatable"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 31
          // }
        ]
      },
      "Load N' Go DNA/RNA Viral Kit": {
        "title": "Load N' Go DNA/RNA Viral Kit",
        "catalogNumbers": "R2143",
        "description": "Pre-loaded laboratory automation-ready reagent plates for high-throughput purification of viral DNA and/or RNA from plasma, serum, urine, cell culture media, blood, saliva, cellular suspensions, biopsies and swab and fecals samples stored in DNA/RNA Shield.",
        "handle": "/products/load-n-go-dna-rna-viral-kit",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2143_Quick-DNA-RNA-Viral-Automation-Kit-Photo-for-Flyer.jpg?v=1667426568&width=600",
        "generalIndex": "83",
        "id": "load-n-go-dna-rna-viral-kit",
        "tags": [
          "blood",
          "cells",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "proteinase-k-included",
          "high-throughput",
          "automated-high-throughput",
          "total-nucleic-acid-dna-rna-purification",
          "magnetic-beads-automatable"
        ],
        "filters": []
      },
      "Quick-DNA/RNA HT": {
        "title": "<i>Quick</i>-DNA/RNA HT Kit",
        "catalogNumbers": "R2150, R2150-E, R2151, R2151-E",
        "description": "Clinical, high-throughput, magnetic bead-based purification of total nucleic acid (DNA/RNA) from any clinical sample (e.g., host, plasma, serum, urine, cell culture media, blood, saliva, cellular suspensions, swab, fecal and biopsies).",
        "handle": "/products/quick-dna-rna-ht",
        "navigation_image": "https://www.zymoresearch.com/cdn/shop/products/LowResProductImage-R2150-E_-R2151-E-Quick-DNA-RNA-HT_Dx_1200x.jpg",
        "generalIndex": "84",
        "id": "quick-dna-rna-ht",
        "tags": [
          "microbial-cultures",
          "all-purpose-extraction",
          "bacteria",
          "blood",
          "cells",
          "tissue",
          "insect",
          "plant-seed",
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "ce-ivd",
          "proteinase-k-included",
          "total-nucleic-acid-dna-rna-purification",
          "high-throughput",
          "automated-high-throughput",
          "magnetic-beads-automatable"
        ],
        "filters": []
      },
      "Quick-DNA/RNA FFPE Miniprep Kit": {
        "title": "<i>Quick</i>-DNA/RNA FFPE Miniprep Kit",
        "catalogNumbers": "R1009",
        "description": "A simple and reliable method for total nucleic acid isolation (DNA & RNA) from the same formalin-fixed, paraffin embedded (FFPE) tissue sample.",
        "handle": "/products/quick-dna-rna-ffpe-miniprep-kit",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1009_Quick-DNA-RNA-FFPE-Kit.jpg?v=1628532355&width=600",
        "generalIndex": "91",
        "id": "quick-dna-rna-ffpe-miniprep-kit",
        "tags": [
          "ffpe",
          "proteinase-k-included",
          "total-nucleic-acid-dna-rna-purification",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-cfRNA/cfDNA Serum & Plasma Kit": {
        "title": "<i>Quick</i>-cfRNA/cfDNA Serum & Plasma Kit",
        "catalogNumbers": "R1072",
        "description": "Simple and efficient preparation of all circulating cell-free DNA and RNA from serum, plasma, and other biological fluids without toxic phenol-chloroform or cumbersome protein precipitation and removal steps.",
        "handle": "/products/quick-cfdna-rna-serum-plasma-kit",
        "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1072_Quick-cfDNA-cfRNA-Serum-adn-Plasma-Kit_Green-Label_e29d48c4-05d8-4232-a171-2bf3523354c9.jpg?v=1628532354&width=600",
        "generalIndex": "90",
        "id": "quick-cfdna-rna-serum-plasma-kit",
        "tags": [
          "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
          "swabs-and-saliva",
          "urine",
          "proteinase-k-included",
          "cell-free-dna",
          "total-nucleic-acid-dna-rna-purification",
          "spin-columns"
        ],
        "filters": []
      },
      "Quick-DNA/RNA Water Kit": {
        "title": "<i>Quick</i>-DNA/RNA Water Kit",
        "catalogNumbers": "R2044",
        "description": "The <i>Quick</i>-DNA/RNA Water Kit efficiently isolates inhibitor-free nucleic acids from large water samples, ideal for sensitive applications like ddPCR, RT-qPCR, and NGS.",
        "handle": "/products/quick-dna-rna-water-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna_rna_co_extraction/R2044.webp",
        "generalIndex": "92",
        "id": "quick-dna-rna-water-kit",
        "tags": [
          "bacteria",
          "soil-and-water",
          "virus",
          "yeast-fungi",
          "microbiome-metagenome-analysis",
          "physical-lysis",
          "total-nucleic-acid-dna-rna-purification",
          "spin-columns",
          "high-sample-input",
          "certified-low-bioburden"
        ],
        "filters": []
      }
    }
  }